import { colors } from '@components/ListItemFacility/styles';
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import breakpoint from 'styled-components-breakpoint';

export const CarouselOuterWrapper = styled.div`
  padding: ${props => (props.pagination ? '' : '0 40px')};
  width: ${props => (props.pagination ? '' : 'calc(100% - 80px)')};
  position: relative;

  ${breakpoint('mobile', 'tablet')`
    padding: 40px 0px;
    padding-top: 0px;
    width: 100%;
  `}
`;

export const CarouselItem = styled.div`
  flex: 0 0 ${({ width }) => `${width}%`};
  cursor: pointer;
  width: ${({ width }) => `${width}%`};
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CarouselContainer = styled.div`
  position: relative;
  overflow-x: hidden;
  overflow-y: visible;
  width: 100%;
  z-index: 2;
  padding-top: ${({ paddingTop }) => paddingTop && `${paddingTop}rem`};
`;

export const CarouselInnerImage = styled.img`
  width: calc(100% - 20px) !important;
  ${({ active }) => active && `border: 2px solid ${colors.navyGray}`};
  aspect-ratio: 1;
  margin: 0px !important;
`;

export const Carousel = styled(Grid)`
  width: ${({ onScreenCount, totalChild }) => `${Math.ceil(totalChild / onScreenCount) * 100}%`};
  transform: ${({ currentIndex, moveValue }) => `translateX(-${currentIndex * moveValue}%)`};
  display: flex;
  ${breakpoint('tablet', 'desktop')`
  justify-content:flex-start;
  flex-wrap: nowrap;
  `}
  transition: transform 0.5s ease;
`;

export const CarouselControls = styled.div`
  display: ${props => (props.HideArrow === false ? 'none' : 'flex')};
  position: absolute;
  z-index: 1;
  top: ${props => (props.pagination ? '' : '50%')};
  left: 0px;
  right: 10px;
  margin-top:${props => (props.pagination ? '2rem' : '')};
  transform: translateY(-50%);
  justify-content: ${props => (props.pagination ? 'center' : 'space-between')};
  align-items: center;
  ${({ blogs }) => blogs && `
     margin-top: 1rem;
  `}
  ${breakpoint('mobile', 'tablet')`
    top: 100%;
  `}
`;

export const CarouselControl = styled.div`
  background: none;
  border: none;
  font-size: 24px;
  color: #000;
  cursor: pointer;
  img {
    height:  ${props => (props.pagination ? '35px' : '30px')};
    padding: 10px;
    background-color: ${props => (props.pagination ? '' : '#f4f4f4')};
    border-radius: 8px;
    ${({ hide }) =>
    hide
      && `
     opacity: 0.2;
     cursor: not-allowed;
    `};
  }
  ${breakpoint('mobile', 'tablet')`
    display: none;
  `}
`;
